
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.361 29.322"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.297 27.692a1.629 1.629 0 01-3.258 0v-9.773a1.629 1.629 0 013.258 0zm8.145 0a1.629 1.629 0 01-3.258 0v-14.66a1.629 1.629 0 013.258 0zm8.145 0a1.629 1.629 0 01-3.258 0V14.661a1.629 1.629 0 013.258 0zm8.145 0a1.629 1.629 0 01-3.258 0V9.774a1.629 1.629 0 113.258 0zM2.686 12.673A1.629 1.629 0 11.65 10.132l8.145-6.516a1.629 1.629 0 011.622-.241l7.35 2.939 9.06-6.04a1.63 1.63 0 011.808 2.711L18.862 9.5a1.629 1.629 0 01-1.508.156l-7.265-2.9-7.4 5.923z","fill":"#3d9ed3"}})])
          )
        }
      }
    